import { getRouteApi, Outlet } from '@tanstack/react-router';
import * as React from 'react';

import { useCampaignDetail } from '@/api/use-campaigns';
import { CampaignZoneNav } from '@/routes/admin/campaigns/campaign-zone-nav';

// =============================================================================
// campaign-zone-layout-route.tsx — Layout PARENT de la zone campagne (DBU §2.5 l.1057-1059).
// =============================================================================
// Route-layout de « /admin/campaigns/$campaignId » : parent commun de TOUTES les pages de la zone
// (détail, suivi, vue opérationnelle, prix cibles, rang, analyse, publication, négociation). Rend le
// <CampaignCycleNavigator> EN PERMANENCE au-dessus de l'<Outlet/> (depuis le restyling 2026-09-17, logé dans la
// barre haute de <CampaignZoneNav>) — le navigateur de cycle est donc
// transverse à la zone (parité DBU « affiché sur TOUTES les pages de la zone »), et non plus confiné au
// hub détail. La frontière chrome (AppShell) reste gouvernée par le composant racine (SEC-NAV-01).
//
// L'état de campagne (autorité API) alimente la frise : la lecture se fait via useCampaignDetail, dont la
// clé de query est partagée avec les écrans de la zone (déduplication TanStack Query — aucun fetch en
// double). Tant que l'état n'est pas résolu, seul l'<Outlet/> est rendu (l'écran enfant porte son propre
// état de chargement) ; le navigateur apparaît dès que l'état est disponible.

const routeApi = getRouteApi('/admin/campaigns/$campaignId');

export function CampaignZoneLayoutRoute(): React.JSX.Element {
  const { campaignId } = routeApi.useParams();
  const detail = useCampaignDetail(campaignId);

  return (
    <div className="space-y-6">
      {detail.isSuccess ? (
        // Navigation transverse (barre haute : fil d'Ariane + navigateur de cycle ; intitulé ; onglets) :
        // identique sur toutes les pages de la zone, page courante mise en évidence. Portée UNIQUEMENT ici (DRY).
        <CampaignZoneNav campaign={detail.data} />
      ) : null}
      <Outlet />
    </div>
  );
}
